/**
 * https://web.dev/articles/optimize-long-tasks?hl=ru
 *
 * @returns Promise<void>
 */
export const yieldToMainThread = (): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(resolve, 0)
  })
}

export const sleep = async (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
